import { render, staticRenderFns } from "./AdditionalPlannedSurgeryCode.vue?vue&type=template&id=53ad7b7b&scoped=true"
import script from "./AdditionalPlannedSurgeryCode.vue?vue&type=script&lang=js"
export * from "./AdditionalPlannedSurgeryCode.vue?vue&type=script&lang=js"
import style0 from "./AdditionalPlannedSurgeryCode.vue?vue&type=style&index=0&id=53ad7b7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ad7b7b",
  null
  
)

export default component.exports